import { getProductType } from '../helpers/getProductType'

import type { EProductType, TProduct } from '../type'
import type { ReactNode } from 'react'

export interface TListItem {
  label: ReactNode
  enabled: boolean
  showIcon?: boolean
  tooltipContent?: ReactNode
}
interface TPlanFeatureMapValue {
  requestWords: (product: TProduct) => ReactNode | null
  wordsText: (product: TProduct) => ReactNode
  featuresTextList: (product: TProduct) => TListItem[] | undefined
  featuresTitle: ReactNode
}

export interface TPlanFeatureMap {
  [EProductType.FREE]: TPlanFeatureMapValue
  [EProductType.BASIC]: TPlanFeatureMapValue
  [EProductType.PRO]: TPlanFeatureMapValue
  [EProductType.UNLIMITED]?: TPlanFeatureMapValue
  [EProductType.ULTIMATE]?: TPlanFeatureMapValue
}

const defaultValue = {
  requestWords: null,
  wordsText: null,
  featuresTextList: [],
  checkForAiText: null,
  featuresTitle: null,
  featuresTitle2: null,
  featuresTextList2: [],
}

export function useProductText({
  product,
  PlanFeatureMap,
}: {
  product: TProduct
  PlanFeatureMap: TPlanFeatureMap
}) {
  const productType = getProductType({ product })

  const feature = PlanFeatureMap[productType]
  if (!feature) {
    return defaultValue
  }

  const requestWords = feature.requestWords(product)
  const wordsText = feature.wordsText(product)
  const featuresTextList = feature.featuresTextList(product)
  const featuresTitle = feature?.featuresTitle

  return {
    requestWords,
    wordsText,
    featuresTextList,
    featuresTitle,
  }
}

export type TUseProductText = ReturnType<typeof useProductText>
